module.exports = __webpack_public_path__ + "static/media/empresa.306681e2.jpg";